import {FC, useEffect} from 'react';
import IdentityPageLayout from '@/features/identity/components/IdentityPageLayout.tsx';
import NewPasswordForm from '@/features/identity/components/NewPasswordForm.tsx';
import {useSignOut} from './hooks/useSignOut';

const NewPasswordPage: FC = () => {
    const signOut = useSignOut();

    useEffect(() => {
        signOut();
    }, []);

    return (
        <IdentityPageLayout>
            <NewPasswordForm />
        </IdentityPageLayout>
    );
};

export default NewPasswordPage;
